import { render, staticRenderFns } from "./ChannelSettingsOverview.vue?vue&type=template&id=18d242b2&scoped=true"
import script from "./ChannelSettingsOverview.vue?vue&type=script&lang=js"
export * from "./ChannelSettingsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d242b2",
  null
  
)

export default component.exports